import React, { useEffect, useState } from "react";
import Base from '../../utils/base'
import moment from "moment";

export default function Header(props) {
  var base = new Base()
  const momentNow = moment()
  const [infoData, setInfoData] = useState({})
  
  useEffect(() => {
      get_info_data()
    }, [])
  
    async function get_info_data() {
      var response = await base.request(base.url_api + "/info?type=gallery")
  
      if(response != null){
        if(response.status == "success"){
          setInfoData(response.data)
        }
        else
          base.show_error(response.message)
      }
      else
        console.log('Server Error')
    }

  return (
    <section className="page-header">
      <div className="page-header__bg" style={{ backgroundImage: "url(" + infoData.url_image1 + ")", }}></div>
      <div className="container">
        {/* <img src="assets/images/shapes/page-header-s-1.png" alt="Gallery" className="page-header__shape" /> */}
        <h2 className="page-header__title">{infoData.title}</h2>
        {/* <ul className="solinom-breadcrumb list-unstyled">
          <li><a href="index.html">Home</a></li>
          <li><span>Gallery</span></li>
        </ul> */}
      </div>
    </section>
  );
};
